import axios, { AxiosInstance } from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

export const http: AxiosInstance = axios.create({
    baseURL,
})
